import React from 'react';
import { connect } from 'react-redux';

import './FlashMessage.scss';


class FlashMessage extends React.Component {
    render() {
        const {
            flashMessage = {},
        } = this.props;

        const {
            message,
        } = flashMessage;

        const flashClass = `flash-message alert alert-dismissable fade in show alert-${flashMessage.messageType}`;

        if (flashMessage.message) {
            return (
                <div className={flashClass} data-dismiss="alert">
                    {message}
                </div>
            );
        }
        return null;
    }
}

function mapState(state) {
    return {
        flashMessage: state.flashMessage,
    };
}

export default connect(mapState)(FlashMessage);
